import { parse } from "csv-parse/sync"

export function parseTable(fileContent: string): { [key: string]: string } {
  const unitMapping: { [key: string]: string } = {}
  const parsedContend = parse(fileContent, { delimiter: ";", trim: true, columns: true })
  parsedContend.forEach(({ sourceUnit, targetUnit }) => {
    unitMapping[sourceUnit] = targetUnit
  })
  return unitMapping
}
